<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <div class="h-full flex flex-col ">
    <div class="grow">
      <prox-budget-items [isReadOnly]="parent.isReadOnly()" [accountId]="program.accountId" [budgets]="programBudgets" [joBudgetLogs]="joBudgetLogs" [isProgramBudget]="true" addLabel="Add Budget Items"
        [createEntityFn]="createProgramBudget.bind(this)" [isReadOnly]="parent.isReadOnly()"></prox-budget-items>
    </div>
  </div>
</div>
